// Chunked upload helper — sends a file to the backend in small parts so each request
// stays well under any reverse-proxy request-body-size limit (and avoids upload
// timeouts on large videos). Returns the finished upload reference: { upload_id, path, ... }.
//
// Flow: POST /admin/uploads/init → PUT /admin/uploads/{id}/chunk (xN) → POST .../finish
import { api } from '@/lib/api';

export async function chunkedUpload(file, purpose, onProgress) {
    const init = await api.post('/admin/uploads/init', {
        filename: file.name || 'file.bin',
        content_type: file.type || 'application/octet-stream',
        total_size: file.size,
        purpose,
    });
    const uploadId = init.data.upload_id;
    const chunkSize = init.data.chunk_size || 512 * 1024;

    let offset = 0;
    let index = 0;
    while (offset < file.size) {
        const end = Math.min(offset + chunkSize, file.size);
        const blob = file.slice(offset, end);
        // Send raw bytes (octet-stream) — no multipart overhead, tiny request body.
        // `index` lets the backend store each part in Mongo and reassemble in order,
        // so uploads survive multi-pod routing and restarts.
        await api.put(`/admin/uploads/${uploadId}/chunk?index=${index}`, blob, {
            headers: { 'Content-Type': 'application/octet-stream' },
            transformRequest: [(d) => d],
        });
        offset = end;
        index += 1;
        if (onProgress) onProgress(Math.min(99, Math.round((offset / file.size) * 100)));
    }

    const fin = await api.post(`/admin/uploads/${uploadId}/finish`, {});
    if (onProgress) onProgress(100);
    return fin.data; // { upload_id, path, size, content_type }
}
